module.exports = __webpack_public_path__ + "img/gitlab.e99e8d4.webp";